import { render, staticRenderFns } from "./AssignedUser.vue?vue&type=template&id=71bb9b5c"
import script from "./AssignedUser.vue?vue&type=script&lang=js"
export * from "./AssignedUser.vue?vue&type=script&lang=js"
import style0 from "./AssignedUser.vue?vue&type=style&index=0&id=71bb9b5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports